
import { defineComponent } from 'vue'
import Dropdown from '@/components/shared/Dropdown.vue'
import { DropdownOptionResponse } from '@/@types/responses/common/DropdownOptionResponse'

export default defineComponent({
  name: 'Paginator',
  components: {
    Dropdown
  },
  props: {
    totalResults: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      required: true
    },
    pageNumber: {
      type: Number,
      required: true
    }
  },
  emits: ['pageChange', 'page-size-change'],
  data() {
    const dropdownOptions = [
      new DropdownOptionResponse(10, true, '10'),
      new DropdownOptionResponse(25, true, '25'),
      new DropdownOptionResponse(50, true, '50')
    ]

    return {
      dropdownOptions,
      itemsPerPage: this.pageSize
    }
  },
  computed: {
    lastPageNumber(): number {
      if (this.totalResults === 0) return 1
      return Math.ceil(this.totalResults / this.pageSize)
    },
    resultsText(): string {
      const firstResultNumber = this.totalResults === 0 ? 0 : ((this.pageNumber - 1) * this.pageSize) + 1
      const maximumPossibleResultNumber = this.pageNumber * this.pageSize
      const endingResultNumber = maximumPossibleResultNumber > this.totalResults ? this.totalResults : maximumPossibleResultNumber
      return `Results ${firstResultNumber} - ${endingResultNumber} of ${this.totalResults}`
    },
    visiblePageNumbers(): number[] {
      if (this.pageNumber >= 1 && this.pageNumber <= this.lastPageNumber) {
        let numbers = [this.pageNumber]

        if (this.pageNumber === 1) {
          if (this.totalResults > this.pageSize)
            numbers.push(2)
          if (this.totalResults > (this.pageSize * 2))
            numbers.push(3)
        } else if (this.pageNumber === this.lastPageNumber) {
          if (this.totalResults > this.pageSize)
            numbers.push(this.lastPageNumber - 1)
          if (this.totalResults > (this.pageSize * 2))
            numbers.push(this.lastPageNumber - 2)
        } else {
          numbers.push(this.pageNumber - 1)
          numbers.push(this.pageNumber + 1)
        }

        numbers = numbers.sort((a, b) => a - b).filter((elem, index, arr) => arr.indexOf(elem) === index)
        
        return numbers
      } else {
        this.pageNumber < 1 ? this.changePage(1) : this.changePage(this.lastPageNumber)
        return []
      }
    }
  },
  watch: {
    itemsPerPage(currentValue: number, oldValue: number): void {
      if (currentValue !== oldValue)
        this.$emit('page-size-change', this.itemsPerPage)
    }
  },
  methods: {
    changePage(selectedPage: number): void {
      this.$emit('pageChange', selectedPage)
    }
  }
})

